import React from 'react';
import styled from '@emotion/styled';
import { Icon } from '@gumtree/ui-library';

const IcnCheck = styled(Icon)`
    margin-left: 6px;
    line-height: inherit;
`;

const Tick: React.FC = () => <IcnCheck type="check" />;

export default Tick;
